const Progress = {
  highestCompletedLevel() {
    var level = parseInt(window.localStorage.highestCompletedLevel, 10);
    return isNaN(level)? -1 : level;
  },

  setHighestCompletedLevel(level) {
    window.localStorage.highestCompletedLevel = Math.max(this.highestCompletedLevel(), level);
  },

  bestMoney() {
    return window.localStorage.bestScoreC;
  },

  setBestMoney(money) {
    window.localStorage.bestScoreC = money;
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/models/Progress.js